

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface BankTransParameter extends Parameter {
    SearchTerm: number;
    OrderBy: string;
  
}

export interface BankTrans {
  employeeDet?: any;
  bankDet?: any;
  

    transactionType?: string;
    transDoneby: any;   
    bankId: any;
    transactionDate:any;
    transPaymode:string;
    transdeposits:any;
    transwithdrwals:any;
    transRefNo:string;

    transRefDate:any;
    transRefNotes: any;
    createdBy:any,
    createdDate:any,
    updatedBy:any,
    updatedDate:any,

    tenantId?: string;
    BranchId?: string;

    
  parameters?: BankTransParameter[];
  links?: any;
}

export abstract class BankTransData {

  abstract list(url: string): Observable<BankTrans[]>;
  abstract create(url: string,data: BankTrans): Observable<any>;
  abstract update(url: string,data: BankTrans): Observable<any>;
  abstract delete(url: string): Observable<any>;
  abstract searchList(url: string,data:any): Observable<any>;
}

